import { render, staticRenderFns } from "./ForumItemTeam.vue?vue&type=template&id=8952285c&scoped=true"
import script from "./ForumItemTeam.vue?vue&type=script&lang=js"
export * from "./ForumItemTeam.vue?vue&type=script&lang=js"
import style0 from "./ForumItemTeam.vue?vue&type=style&index=0&id=8952285c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8952285c",
  null
  
)

export default component.exports